<template>
  <article class="layout-section -bg-shade" :class="{ '-alt-top': !isFirst }">
    <div class="layout-section__hgroup">
      <h3 class="layout-section__title -small -no-space">{{ group.title }}</h3>
      <p>{{ group.description }}</p>
    </div>

    <section class="layout-grid">
      <div v-for="{ name } in group.members" :key="name" class="layout-grid__item card -smaller">
        <p>{{ name }}</p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutMembersIndex',
  props: {
    group: Object,
    isFirst: Boolean
  }
}
</script>
